export default __webpack_public_path__ + "static/media/SimplyServeSmall.701a1c3d.png";